"use client";

import Script from "next/script";
import React, { createContext } from "react";
import { reportAuthError } from "../lib/analytics";
import { AUTH_CONFIG } from "./config";

const publicToken = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || "";
const publicTokenB2B = process.env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN || "";

type StytchTelemetryContextProps =
  | {
      isReady: true;
      getTelemetryID: () => Promise<string>;
    }
  | {
      isReady: false;
      getTelemetryID: null;
    };

export const StytchTelemetryContext =
  createContext<StytchTelemetryContextProps>({
    isReady: false,
    getTelemetryID: null,
  });

export const useStytchTelemetry = () =>
  React.useContext(StytchTelemetryContext);

export const StytchTelemetryProvider = ({
  children,
}: { children: React.ReactNode }) => {
  const [scriptReady, setScriptReady] = React.useState(false);

  const getTelemetryID = async (): Promise<string> => {
    const config = {
      submitURL: "https://gste.groq.io/submit",
      publicToken: AUTH_CONFIG.isB2B ? publicTokenB2B : publicToken,
    };
    // @ts-ignore
    return await window.GetTelemetryID(config);
  };

  const value: StytchTelemetryContextProps = scriptReady
    ? {
        isReady: true,
        getTelemetryID: getTelemetryID,
      }
    : {
        isReady: false,
        getTelemetryID: null,
      };

  return (
    <>
      <Script
        src="https://api.stytchb2b.groq.com/telemetry.js"
        onError={(e) => {
          reportAuthError(`Stytch Telemetry Script Error: ${e.message}`);
        }}
        onReady={() => {
          setScriptReady(true);
        }}
      />
      <StytchTelemetryContext.Provider value={value}>
        {children}
      </StytchTelemetryContext.Provider>
    </>
  );
};
